module.exports = __webpack_public_path__ + "img/ie.d170d002.svg";